import { alertDialog, guardDialog } from '@adornis/dialog/dialog-functions.js';
import { askForTextFile } from '@adornis/file-utils/client/helper-methods.js';
import { ExpectedError } from '@adornis/validation/errors/ExpectedError.js';
import { AbwesenheitenImport, importAbwesenheiten } from '../../db/import-export/abwesenheiten-import.js';

// TODO this functions are not commented well. I spülit them from the calender logic and by reading some code this parses html files from untis? Maybe we should do this serverside?

function getRowItems(doc: Document) {
  // Selector for selecting the list of absence data of html file
  const absenceListDataSelector = 'tr.list.odd, tr.list.even';
  const rows = doc.querySelectorAll(absenceListDataSelector);
  const dataMap = new Map<string, AbwesenheitenImport>();
  const nameAbbreviations: string[] = [];
  rows.forEach(row => {
    // Selector for selecting Lehrer data of html file
    const sElement = row.querySelector('s');
    if (!sElement) return;
    const cells = row.querySelectorAll('td');
    const [lessonDaten, reasonAbbreviation] = Array.from(cells, (cell: any) => cell.textContent?.trim() || '');
    const lesson: number[] = lessonDaten.includes('-')
      ? lessonDaten.split('-').map((part: string) => part.trim())
      : [lessonDaten];
    const dataKey: string = sElement.textContent + reasonAbbreviation + lesson.toString().replaceAll(',', '');
    if (!sElement.textContent) return;
    dataMap.set(
      dataKey,
      new AbwesenheitenImport({
        lesson,
        reasonAbbreviation,
        name: sElement.textContent,
      }),
    );
    nameAbbreviations.push(sElement.textContent);
  });
  return { dataMap, nameAbbreviations };
}

export async function importUnitsAbwesenheiten() {
  const file = await askForTextFile({ forcedEncoding: 'utf-8', acceptFileTypes: '.html,.htm' });
  if (!/<[a-z][\s\S]*>/i.test(file)) {
    void alertDialog('Bitte stellen Sie sicher, dass Sie eine Untis-Datei auswählen!');
    return;
  }

  await guardDialog(async () => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(file, 'text/html');
    const monTitle = doc.querySelector('.mon_title');
    const regex = /(\d{2})\.(\d{2})\.(\d{4})/;
    const match: RegExpExecArray | null = regex.exec(monTitle?.textContent ?? '');
    if (!match) {
      throw new ExpectedError('Bitte stellen Sie sicher, dass Sie eine Untis-Datei auswählen!');
    }
    const [, dayMatch, monthMatch, yearMatch] = match;
    if (!yearMatch || !monthMatch || !dayMatch) return;
    const { dataMap, nameAbbreviations } = getRowItems(doc);
    await importAbwesenheiten([...dataMap.values()], nameAbbreviations, dayMatch, monthMatch, yearMatch)();
  });
}
